<template>
  <div v-if="true">

    <el-row :gutter="24">
      <el-col :xs="24">
        <user-info :visit="visit" :loading="loadingVisit"/>

        <collapse-card :loading="loadingCard"
                       open
                       class="questions-card" style="">
          <div slot="title">Состояние здоровья</div>
          <div
              :label="item.title"
              :name="item.id.toString()"
              v-for="item of questionnaireOne"
              :key="item.id"
              style="pointer-events: none"
          >
            <div class="title">{{ item.title }}</div>

            <el-checkbox-group v-model="pollQuestionnaireOne">
              <el-checkbox-button
                  v-for="tag in item.questions"
                  :label="tag.id"
                  :key="tag.id"
              >{{ tag.text }}
              </el-checkbox-button>
            </el-checkbox-group>
          </div>
        </collapse-card>


        <collapse-card :loading="loadingCard"
                       open
                       class="questions-card">
          <div slot="title">Постоянная анкета</div>

          <div
              :label="item.title"
              :name="item.id.toString()"
              v-for="item of questionnaireTwo"
              :key="item.id"
              style="pointer-events: none"
          >
            <div class="title">{{ item.title }}</div>
            <el-checkbox-group v-model="pollQuestionnaireTwo">
              <el-checkbox-button
                  v-for="tag in item.questions"
                  :label="tag.id"
                  :key="tag.id"
              >{{ tag.text }}
              </el-checkbox-button>
            </el-checkbox-group>
          </div>
        </collapse-card>


        <el-row class="btn">
          <el-button type="primary" @click="goDevices">Далее</el-button>
          <el-button @click="goDevices">Пропустить</el-button>
        </el-row>

      </el-col>
    </el-row>
  </div>
</template>

<script>
import {mapActions, mapMutations} from "vuex"
import Vue from "vue"
import VueMask from "v-mask"

import UserInfo from "@/components/visit/UserInfo.vue"
import CollapseCard from "@/components/elements/BigCard.vue"

Vue.use(VueMask)

export default {
  name: "Visit.item",
  components: {

    UserInfo,
    CollapseCard
  },
  data: function () {
    return {
      visit: {
        user: {},
        worker: {}
      },
      devices: null,
      loadingVisit: true,
      loadingCard: true,
      questionnaireOne: [],
      pollQuestionnaireOne: [],
      questionnaireTwo: [],
      pollQuestionnaireTwo: [],
    }
  },
  computed: {
    visitId() {
      return this.$route.params.id;
    },
  },
  created() {
    if (this.visitId) this.loadLogic()
    else this.$router.push({name: "visit.list"})

    this.setStageVisit(1);
  },
  filters: {

  },
  methods: {
    ...mapMutations({
      loadOn: "loader/startLoading",
      loadOff: "loader/stopLoading",
    }),
    ...mapActions({
      setStageVisit: "visit/SET_STAGE",
      setComment: "visit/SET_COMMENT",
      setVisit: "visit/SET_DATA",
      loadDocuments: "visit/LOAD_USER_DOCUMENTS",
      loadVisitData: "visit/LOAD_VISIT_DATA",
    }),
    loadLogic() {
      this.loadVisit();
    },
    loadVisit() {
      this.loadingVisit = true;
      this.$api.visit
          .get(this.visitId)
          .then((response) => {
            this.visit = response.data;
            this.loadCardOne(1);

            this.setComment(this.visit.comment)
            this.setVisit(this.visit)
            this.loadDocuments()
            this.loadVisitData({ visitId: this.visitId, neural: true  })

            // if (this.$route.params.goDevice) {
            //    this.goDevices()
            // }
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки списка 😕",
              message: response.response.data.message,
            });
          })
          .finally(() => {
            this.loadingVisit = false
          })
    },
    loadCardOne() {
      this.loadingCard = true

      let params = {
        params: {
          search: 80,
        },
      };
      this.$api.visit
          .getQuestionnaire(this.visitId, params)
          .then((response) => {

            this.questionnaireOne = response.data

            this.loadCardTwo()

            let questionnaireOne = []

            if (!response.data[0].user_questionnaire) return

            response.data[0].user_questionnaire.question_answer.forEach((e) => {
              if (e.answer_bool) {
                response.data[0].questions_grouped.forEach(item => {
                  if (item.children) {
                    item.children.forEach(children => {
                      if (children.id === e.question_id && !questionnaireOne.includes(item.id)) questionnaireOne.push(item.id)
                    })
                  }
                })

                questionnaireOne.push(e.question_id)
              }
            })
            this.pollQuestionnaireOne = questionnaireOne

          })
          .catch((response) => {

            this.$notify.error({
              title: "Ошибка загрузки списка 😕",
              message: response.response.data.message,
            })
            this.$router.push({name: "visit.list"});

          })
          .finally(() => {
            this.loadingCard = false
          })
    },
    loadCardTwo() {
      this.loadingCard = true

      let params = {
        params: {
          search: 100,
        },
      };
      this.$api.visit
          .getQuestionnaire(this.visitId, params)
          .then((response) => {
            this.questionnaireTwo = response.data;
            let questionnaireTwo = [];
            response.data[0].user_questionnaire.question_answer.forEach((e) => {
              if (e.answer_bool)
                questionnaireTwo.push(e.question_id)
            })
            this.pollQuestionnaireTwo = questionnaireTwo

          })
          .catch(() => {
          })
          .finally(() => {
            this.loadingCard = false;
          });

    },
    async goDevices() {
      await this.$router.push({
        name: "visit.device",
        params: {id: this.visit.id, visit: this.visit},
      });
    },
  },
};
</script>

<style scoped lang="scss">
.box-cards {
  @media screen and (min-width: 1000px) {
    display: flex;
    align-items: flex-start;
  }
}

.box-card {
  max-width: 560px;
  border: 0;
  box-shadow: none;
  padding: 0 10px;
}

.title {
  font-weight: 500;
  font-size: 13px;

  line-height: 1;
  color: #111;
  padding: 0;

  margin-top: 20px;
}


.error-load {
  margin: 0 auto;
  text-align: center;
}

.questions {
  margin: 0 auto;
  padding-top: 20px;
}

.questions-item {
  border: 1px solid #dbdbdb;
  background-color: #fff;
  color: #303133;
  transition: 0.3s;
  padding: 20px;
  max-width: 90%;
  margin: 0 0 10px 0;
  border-radius: 4px;
  overflow: hidden;

  &__name {
    color: #000;
    font-weight: 400;
    font-size: 18px !important;
    line-height: 26px;
    display: inline;

    span {
      padding-left: 10px;

      color: #409eff;
      line-height: 26px;
      display: inline;
    }
  }

  &__empty {
    color: #ccc;
  }

  &:hover {
    box-shadow: 2px 2px 24px 2px rgba(0, 0, 0, 0.1);
  }
}

.answer-list {
  padding-left: 10px;

  &-item {
    &__title {
      color: #333;
    }
  }
}

.answer {
  &__title {
    color: #333;
    display: inline-block;
  }
}

.btn {
  margin-top: 40px;
}

.visit-data__center {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .center-description {
    color: #8e8e93;
    font-weight: normal;
    font-size: 11px;
    line-height: 13px;
  }

  .center-name {
    padding: 5px;
    margin-left: 4px;

    font-weight: 500;
    font-size: 12px;
    line-height: 13px;

    letter-spacing: 0.005em;

    color: #111111;

    display: flex;
    align-items: center;
  }
}

.questions-card {
  max-width: 100% !important;

  .title {
    margin: 20px 0 10px 0;

    display: flex;
    align-items: center;
    letter-spacing: 0.005em;


    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 20px;
    color: #8E8E93;
  }
}
</style>
